import React, { useEffect, useContext } from 'react';

import {
    Grid
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    BlockMenu
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => {
    root: { }
});

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady
    } = useContext(PageContext);

    const {
    } = state;

    return (
        <>
            {pageIsReady &&
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            title="Dashboard"
                            subtitle="Administration dashboard"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <BlockMenu />
                    </Grid>
                </Grid>
            }
        </>
    );
}

export const DashboardPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}